<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Icon from '../../components/Icon.svelte';
  import Text from '../../components/Text.svelte';

  export let storyId;
  export let isExpanded: boolean = false;
  const dispatch = createEventDispatcher();

  // Function to toggle expansion state
  function toggleExpand() {
    isExpanded = !isExpanded;
    dispatch('toggleExpand', isExpanded);
  }
</script>

<div class="story-accordion-container">
  <!-- svelte-ignore a11y-interactive-supports-focus -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-missing-attribute -->
  <a
    class="story-accordion-section"
    on:click={toggleExpand}
    data-bs-toggle="collapse"
    data-bs-target="#{storyId}"
    role="button"
  >
    <span>
      <Text key={isExpanded ? 'extra.hide.text' : 'extra.show.full.story.text'} />
    </span>
    <div class="down-arrow" class:rotate180={isExpanded}>
      <Icon type="font" glyph="chevron_down" mobileSize={18} desktopSize={30} />
    </div>
  </a>
</div>

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .story-accordion-section {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    @include desktop-max-width {
      gap: 8px;
      justify-content: center;
    }
    span {
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
      text-decoration: underline;
      @include desktop-max-width {
        font-size: 12px;
      }
    }
    .rotate180 {
      transform: rotate(180deg);
    }
  }
</style>
